module.exports = __webpack_public_path__ + "static/media/lampa-min.c9deaad9.png";